/** Tenant Schema Git 仓库内 profile 目录（pydc-tenants-config-store 约定） */
export const SCHEMA_PROFILES_DIR = 'schema/profiles';

/** 同一仓内工作流声明目录：workflow/{schema_profile}/*.json */
export const WORKFLOW_PROFILES_DIR = 'workflow';
